import React, { ReactNode } from "react";
import styled from "styled-components";
import { NoItems } from "./NoItems";
import { RequestStatus } from "../constants/RequestStatus";

interface Props {
  children?: ReactNode;
  fallback: NonNullable<ReactNode> | null;
  requestStatus: RequestStatus;
  tableData: unknown[];
  noDataContent?: string;
}

const Container = styled.div`
  width: 100%;
`;

export const Suspense: React.FC<Props> = ({
  children,
  fallback,
  requestStatus,
  tableData,
  noDataContent,
}: Props) => {
  const renderChildren = React.useCallback(() => {
    if (tableData?.length > 0) {
      return children;
    }
    return <NoItems {...(noDataContent && { content: noDataContent })} />;
  }, [children, noDataContent, tableData]);

  return (
    <Container>
      {requestStatus === RequestStatus.PENDING && fallback}
      {requestStatus === RequestStatus.SUCCESS && renderChildren()}
      {requestStatus === RequestStatus.FAILED && (
        <div>Fetching data failed, refresh page</div>
      )}
    </Container>
  );
};
